import ClaimLeadButton from './ClaimLeadButton';

export default ClaimLeadButton;
